import { useEffect } from 'react';
import { useGameCardGuideStore, GameCardGuideConfig } from 'lib/store/gameCardGuideStore';
import gameCardGuideService from 'lib/services/gameCardGuideService';
import { useFinishInit } from 'lib/hooks/useFinishInit';
import { ComponentProps } from 'types';

export default function GameCardGuide({ data }: ComponentProps<Partial<GameCardGuideConfig>>) {
  useEffect(() => {
    useGameCardGuideStore.getState().initGameCardGuideConfig({
      enabled: data.enabled ?? false,
      guideText: data.guideText ?? '',
      guideIcon: data.guideIcon ?? '',
      noGiftButtonText: data.noGiftButtonText ?? '',
      guideUrl: data.guideUrl ?? '',
      isOrderRequired: data.isOrderRequired ?? false,
    });
  }, [data]);

  useFinishInit(() => {
    gameCardGuideService.resumePendingGuideNavigation();
  });

  return null;
}
